import cn from 'classnames';

export default function LdsSticky({
  children,
  style = {},
  top = 0,
  className,
  ...rest
}) {
  return (
    <div
      className={cn(
        'lds-sticky',
        className
      )}
      style={{
        top,
        position: 'sticky',
        zIndex: 100,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}
